import { TableField } from "../table-field";

const notificacao: TableField = {
  key: "Notificacao",
  label: "Notificação",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const processo: TableField = {
  key: "CodTCE",
  label: "Processo",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const tipo: TableField = {
  key: "DescricaoTipoNotificacao",
  label: "Tipo",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const descricao: TableField = {
  key: "Descricao",
  label: "Descrição",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const notificado: TableField = {
  key: "Notificado",
  label: "Notificado",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const dataPublicacao: TableField = {
  key: "DataPublicacao",
  label: "Data Notificação",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
  formatter: (val) => (val ? val.toLocaleDateString() : ""),
};
const prazoVencimento: TableField = {
  key: "prazoVencimento",
  label: "Prazo para vencimento",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const dataResposta: TableField = {
  key: "DataResposta",
  label: "Data de Resposta",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
  formatter: (val) => (val ? val.toLocaleDateString() : ""),
};
const status: TableField = {
  key: "actions",
  label: "",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};

export const tableFieldsComunicacoesProcessuais: TableField[] = [
  notificacao,
  processo,
  tipo,
  descricao,
  notificado,
  dataPublicacao,
  prazoVencimento,
  dataResposta,
  status,
];
